export const PLACEHOLDER_VALUE = "placeholder";
